import React from 'react';
import firebase from './firebase/firebase';
import { userSignedIn, userSignedOut, userSignInError } from '../redux/User/userActionCreator';
import { connect } from 'react-redux';

function mapDispatchToProps(dispatch){
    return {
        userSignedIn: user=> dispatch(userSignedIn(user)),
        userSignedOut: ()=> dispatch(userSignedOut()),
        userSignInError: (errMess) => dispatch(userSignInError(errMess))
    }
}
class Footer extends React.Component {
    componentDidMount(){ 
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
               user.getIdTokenResult()
                .then((idTokenResult) => {
                    // Confirm the user is an Admin.
                    if (!!idTokenResult.claims.admin) {
                    // Show admin UI.
                        const user1 = {
                            displayName: user.displayName,
                            email: user.email,
                            emailVerified: user.emailVerified,
                            photoURL: user.photoURL,
                            superadmin: !!idTokenResult.claims.superadmin
                        };
                        if(!user1.photoURL)
                        user1.photoURL = document.location.origin + '/images/nodp.jpg';
                        if(!user1.displayName)
                        user1.displayName = user1.email;
                        this.props.userSignedIn(user1);           
                    } else {
                    // Show regular user UI.
                        this.props.userSignInError("Only Admins are allowed to access this content")
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
            }
            else {
              this.props.userSignedOut();
          }
          });
    }
    render(){
        return (
            <>
            </>
        );
    }
}

export default connect(null,mapDispatchToProps)(Footer)